import { isAfter } from "date-fns";
import { Trans } from "react-i18next";
import { Notification } from "@components/Notification/Notification";
import { type IBillData } from "@services/overview/types";

// Hardcoded temporary notification for VS-11696, remove on 2025-01-31
export const useTemporaryProviderBillNotification = (billData: IBillData) => {
  if (
    !billData.customerCode.includes("_DFP") ||
    isAfter(new Date(), new Date("2025-05-01"))
  ) {
    return { Notification: null };
  }

  return {
    Notification: () => (
      <Notification
        description={
          <Trans
            i18nKey={"temporaryProviderBillNotification.description"}
            components={{
              b: <b />,
            }}
          />
        }
        color="red"
      />
    ),
  };
};
